import FeedBackForm from './classes/feedback-form';

// global window defines
declare global {
    interface Window { 
        feedBackForm: FeedBackForm;
     }
}

const globalInit = function () {
    let feedBackForm = new FeedBackForm();
}
globalInit();